import { Button } from "@/components/ui/button";
import Text from "@/components/common/Text";

/**
 * SP4c — /auth/wrong-app route. Shown when Threads BE rejects an Auth0 token
 * because `https://ts/app.id != "threads"` (AppIdValidator). This happens
 * when the user's active app in superapp is set to "portal" instead of
 * "threads" — their session is valid, just scoped to the wrong app.
 *
 * Placeholder behavior until SP4d (superapp launcher tile) lands:
 * - Button link to the superapp home URL. User picks Threads there.
 * - SP4d will replace the link with a smart redirect that auto-switches
 *   active_app to threads and bounces back.
 */
export default function WrongAppPage() {
  // In a real deploy this would come from env; for local dev hardcoded.
  const superappUrl =
    import.meta.env.VITE_PUBLIC_SUPERAPP_URL || "http://localhost:3000";

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-8 bg-white px-6">
      <Text variant="heading_h3" className="text-center text-shades-neutral-500">
        Your portal session isn't scoped to Threads yet
      </Text>
      <Text variant="body_b1" className="max-w-md text-center text-shades-neutral-300">
        You're signed in via Auth0, but your active app in the Thomas Scott
        portal is currently the portal itself, not Threads. Switch to Threads
        in the portal and come back.
      </Text>
      <Button
        type="button"
        onClick={() => {
          window.location.href = superappUrl;
        }}
        className="h-12 px-8"
      >
        Switch to Threads in the portal
      </Button>
    </div>
  );
}
